import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {QrpageManagmentComponent} from './components/qrpage-managment/qrpage-managment.component';
const routes: Routes = [
  {
    path: '',
    component: QrpageManagmentComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QrpagesRoutingModule { }
